import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import convertLayoutProps from "../../utils/convertLayoutProps";
var BoxBase = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var tmp = _param.as, Element = tmp === void 0 ? "div" : tmp, children = _param.children, props = _object_without_properties(_param, [
        "as",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Element, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        children: children
    }));
});
BoxBase.displayName = "BoxBase";
var Box = styled(BoxBase).withConfig({
    componentId: "sc-bad54d23-0"
})(function(_param) {
    var theme = _param.theme, $styles = _param.$styles, props = _object_without_properties(_param, [
        "theme",
        "$styles"
    ]);
    return theme.normalizeStyles(_object_spread({}, convertLayoutProps(props), $styles));
});
export default Box;
